import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../../BASEURL";

export default function Addperson() {
  const [preview, setPreview] = useState(null);
  const [person_name, setPersonName] = useState("");
  const [person_photo, setPersonPhoto] = useState(null);
  const [person_designation, setPersonDesignation] = useState("");
  const [person_role, setPersonRole] = useState("");
  const [person_mobile, setPersonMobile] = useState("");
  const [person_batch, setPersonBatch] = useState("");
  const [designations, setDesignations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDesignations = async () => {
      try {
        const response = await fetch(`${BASE_URL}/api/designations`);
        if (!response.ok) {
          throw new Error('Failed to fetch designations');
        }
        const data = await response.json();
        setDesignations(data);
      } catch (err) {
        console.error('Error fetching designations:', err);
      }
    };

    fetchDesignations();
  }, []);

  const handleImage = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setPersonPhoto(selectedFile);
      setPreview(URL.createObjectURL(selectedFile));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!person_name || !person_photo || !person_designation || !person_role || !person_mobile || !person_batch) {
      setError("Please provide all required fields including selecting a designation.");
      return;
    }

    setLoading(true);
    setError(null);

    const formData = new FormData();
    formData.append("person_name", person_name);
    formData.append("person_photo", person_photo);
    formData.append("person_designation", person_designation);
    formData.append("person_role", person_role);
    formData.append("person_mobile", person_mobile);
    formData.append("person_batch", person_batch);

    try {
      const response = await fetch(`${BASE_URL}/api/persons`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to add person");
      }

      // Success, redirect to person list
      navigate("/admin/personList");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
      <div className="p-6">
        <h1 className="text-2xl font-brand font-bold text-brandBlue mb-6">
          Add Person
        </h1>

        <div className="bg-white p-6 rounded-xl shadow border border-brandLight max-w-xl">

          {/* ERROR MESSAGE */}
          {error && (
            <div className="bg-red-100 text-red-700 p-3 rounded mb-4">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>

            {/* IMAGE PREVIEW */}
            {preview && (
              <img
                src={preview}
                className="w-full h-52 object-cover rounded-md mb-4"
                alt="Preview"
              />
            )}

            <label className="block mb-2 font-medium">Person Name</label>
            <input
              type="text"
              value={person_name}
              onChange={(e) => setPersonName(e.target.value)}
              className="w-full border border-brandLight p-2 rounded mb-4"
              placeholder="Enter Person Name"
              required
            />

            <label className="block mb-2 font-medium">Person Designation</label>
            <select
              value={person_designation}
              onChange={(e) => setPersonDesignation(e.target.value)}
              className="w-full border border-brandLight p-2 rounded mb-4"
              required
            >
              <option value="">Select Designation</option>
              {designations.map((designation) => (
                <option key={designation._id} value={designation._id}>
                  {designation.designation_name}
                </option>
              ))}
            </select>

            <label className="block mb-2 font-medium">Place of Posting</label>
            <input
              type="text"
              value={person_role}
              onChange={(e) => setPersonRole(e.target.value)}
              className="w-full border border-brandLight p-2 rounded mb-4"
              placeholder="Enter Person Role"
              required
            />

            <label className="block mb-2 font-medium">Person Mobile</label>
            <input
              type="tel"
              maxLength="10"
              value={person_mobile}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, ''); // Only allow digits
                setPersonMobile(value);
              }}
              className="w-full border border-brandLight p-2 rounded mb-4"
              placeholder="Enter Person Mobile"
              required
            />

            <label className="block mb-2 font-medium">Person Batch</label>
            <input
              type="text"
              value={person_batch}
              onChange={(e) => setPersonBatch(e.target.value)}
              className="w-full border border-brandLight p-2 rounded mb-4"
              placeholder="Enter Person Batch"
              required
            />

            <label className="block mb-2 font-medium">Upload Person Photo</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleImage}
              className="w-full border border-brandLight p-2 rounded mb-6"
              required
            />

            <button
              type="submit"
              disabled={loading}
              className="bg-brandBlue  text-gold border border-gold px-6 py-2 rounded hover:bg-brandOrange transition disabled:opacity-50"
            >
              {loading ? "Adding..." : "Add Person"}
            </button>
          </form>
        </div>
      </div>
  );
}
